var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaEsq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "seta_esq") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.595923364
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Claro",
    transform: "translate(-45.000000, -592.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(-1.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-4",
    transform: "translate(20.000000, 227.000635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,29 L31.0606058,33.5931667 C30.4772724,34.1356112 29.5227276,34.1356112 28.9393942,33.5931667 L24,29",
    id: "seta_esq",
    transform: "translate(30.000000, 31.500000) rotate(-270.000000) translate(-30.000000, -31.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaEsq);
export default __webpack_public_path__ + "static/media/seta_esq.04e3b9f60fa6b6eb63a0ede23c5d3577.svg";
export { ForwardRef as ReactComponent };